import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-add-codeitem',
  templateUrl: './add-codeitem.component.html',
  styleUrls: ['./add-codeitem.component.css']
})
export class AddCodeitemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/add-codeitem/add-codeitem.component.ts